/* Le kit est un tout dans le panier.

   Six lignes séparées, c'est six façons de casser l'offre : retirer le harnais et garder les
   cadeaux, retirer la laisse et payer 34,99 € pour le contenu du kit. Ici, toute action sur
   une ligne du kit s'applique au groupe entier.

   Le groupe est porté par la propriété de ligne `_Kit`, posée à l'ajout au panier. Le `_`
   la masque au client — même mécanique que le `_Package ID` de FourPaw.

   ponytail: un seul appel `/cart/update.js` par action, avec `sections` pour récupérer le
   tiroir re-rendu dans la même réponse. Pas de second aller-retour, pas de rechargement.
*/
(function () {


  function rowsOf(kit) {
    return Array.from(document.querySelectorAll('[data-kit="' + CSS.escape(kit) + '"]'));
  }

  function busy(rows, on) {
    rows.forEach((r) => {
      const o = r.querySelector('.loading-overlay');
      if (o) o.classList.toggle('hidden', !on);
    });
  }

  /* On refait EXACTEMENT ce que le thème fait après un changement de panier :
     1. basculer `is-empty` sur le tiroir et sur les sections du panier — c'est cette classe
        qui décide d'afficher l'état vide, sans elle on garde l'en-tête et le pied de l'état
        plein par-dessus l'état vide (deux croix, un pied fantôme) ;
     2. ne remplacer que la cible de rendu de chaque section, jamais la section entière :
        remplacer `#shopify-section-cart-drawer` détruit <cart-drawer>, qui perd son état
        ouvert pendant que <body> garde overflow:hidden — tiroir fermé, page figée.
     Cibles reprises du thème : `.drawer__inner` pour le tiroir, la section elle-même sinon. */
  const TARGETS = [
    { section: 'cart-drawer',      host: 'CartDrawer',                          selector: '.drawer__inner' },
    { section: 'cart-icon-bubble', host: 'shopify-section-cart-icon-bubble',    selector: null },
    { section: 'main-cart-items',  host: 'shopify-section-main-cart-items',     selector: null },
    { section: 'main-cart-footer', host: 'shopify-section-main-cart-footer',    selector: null },
  ];

  function refresh(data) {
    const empty = data.item_count === 0;

    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', empty);
    ['main-cart-items', 'main-cart-footer'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.classList.toggle('is-empty', empty);
    });

    const sections = data.sections || {};
    TARGETS.forEach((t) => {
      const html = sections[t.section];
      if (!html) return;
      const host = document.getElementById(t.host);
      if (!host) return;
      const live = t.selector ? host.querySelector(t.selector) : host;
      if (!live) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = t.selector
        ? parsed.querySelector(t.selector)
        : parsed.getElementById(t.host);
      live.innerHTML = fresh ? fresh.innerHTML : html;
    });

    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  async function setGroupQuantity(kit, quantity) {
    const rows = rowsOf(kit);
    const updates = {};
    rows.forEach((r) => { if (r.dataset.key) updates[r.dataset.key] = quantity; });
    if (!Object.keys(updates).length) return;

    busy(rows, true);
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: updates,
          sections: TARGETS.map((t) => t.section).join(','),
          sections_url: window.location.pathname,
        }),
      });
      if (!res.ok) throw new Error('cart update failed');
      refresh(await res.json());
    } catch (e) {
      busy(rows, false);
      window.location.reload();
    }
  }

  function kitOf(el) {
    const row = el.closest('[data-kit]');
    return row ? row.dataset.kit : null;
  }

  /* Capture sur le document : on passe avant les gestionnaires du thème posés sur
     <cart-remove-button> et <quantity-input>, et on les empêche d'agir sur une seule ligne. */
  document.addEventListener('click', function (e) {
    const el = e.target instanceof Element ? e.target : null;
    if (!el) return;

    const remove = el.closest('cart-remove-button');
    if (remove) {
      const kit = kitOf(remove);
      if (!kit) return;
      e.preventDefault();
      e.stopPropagation();
      setGroupQuantity(kit, 0);
      return;
    }

    const step = el.closest('.quantity__button');
    if (step) {
      const kit = kitOf(step);
      if (!kit) return;
      const input = step.parentElement.querySelector('.quantity__input');
      if (!input) return;
      e.preventDefault();
      e.stopPropagation();
      const now = parseInt(input.value, 10) || 1;
      const next = step.name === 'plus' ? now + 1 : now - 1;
      setGroupQuantity(kit, Math.max(0, next));
    }
  }, true);

  document.addEventListener('change', function (e) {
    const el = e.target instanceof Element ? e.target : null;
    if (!el || !el.classList.contains('quantity__input')) return;
    const kit = kitOf(el);
    if (!kit) return;
    e.preventDefault();
    e.stopPropagation();
    setGroupQuantity(kit, Math.max(0, parseInt(el.value, 10) || 0));
  }, true);
})();
